<template>
    <v-container style="margin-top:10px">
            <div v-for="add in ads" :key="add.id">
                <div v-html="add.adcode"></div>
            </div>
    </v-container>
</template>

<script>
import axios from "axios";
import store from "../store";
export default {
    props: ["theme"],
    data: function() {
        return {
            store: store,
            ads : null
        };
    },
    created: async function() {
        if (this.theme) {
            var resp = await axios.get(
                `${this.store.state.baseURL}getadds/${this.theme}`
            );
        } else resp = await axios.get(`${this.store.state.baseURL}getadds/11`);
        this.ads = resp.data.add
    }
};
</script>

<style></style>
